module.exports = __webpack_public_path__ + "static/media/Logo.0b8d84c7.png";